import { SortDir } from '@app/core/constants/sort-dir';

/**
 * Sorts a dataset based on the specified key and direction.
 *
 * @param {T[]} data - The array of objects to be sorted.
 * @param {keyof T} key - The key of the objects to sort by.
 * @param {'asc' | 'desc'} [direction='asc'] - The sort direction, either 'asc' for ascending or 'desc' for descending. Defaults to 'asc'.
 * @return {T[]} A new array sorted based on the specified key and direction.
 */
export function sortDataset<T>(data: T[], key: keyof T, direction: SortDir = 'asc'): T[] {
  return data.sort((a, b) => {
    if (a[key] === b[key]) return 0;

    if (direction === 'asc') {
      return a[key] < b[key] ? -1 : 1;
    } else {
      return a[key] > b[key] ? -1 : 1;
    }
  });
}
